import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IHDCartItemsListRespone } from "@/api_framework/api_modals/Cart";
import { setCartItemsList } from "@/app_redux/reducers/slices/auth/cart_slice";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
//
export const useCartItemsListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (
      customerId: string,
      pincode: string,
      cartType: "normal" | "hd",
      coupon?: string,
      remove_delivery_fee = false,
    ) => {
      try {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CART_MODULE?.HD_CART_ITEMS_LIST?.baseURL}`, {
            params: {
              customer_id: customerId,
              pincode: pincode ?? "",
              cart_level_coupon_id: coupon ? (coupon === "remove" ? undefined : coupon) : undefined,
              remove_coupon: coupon === "remove" ? true : undefined,
              remove_delivery_fee,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IHDCartItemsListRespone>) => {
            if (res.data.status === true) {
              dispatch(setCartItemsList({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(setCartItemsList({ data: null }));
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError<IHDCartItemsListRespone>) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            // Server rejected the request (e.g. pincode not serviceable) — stale items must not stay visible
            if (e.response?.data && e.response.data.status !== true) {
              dispatch(setCartItemsList({ data: null }));
              if (e.response.data.message) toast.error(e.response.data.message);
            }
            dispatch(
              setLoading({
                key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                status: false,
              }),
            );
          });
      } catch (e: any) {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
